export default __webpack_public_path__ + "static/media/shape2mobile.647828ad.svg";